import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG } from '../../shared/common/config';
import { FXResponse } from '../../models/response.model';
import { MapUtils } from '../../shared/utils/mapper';
import { OptionPreviewModel } from '../../models/email-marketing.model';

@Injectable({
  providedIn: 'root',
})
export class EmailMarketingService {

  constructor(private http: HttpClient) {}


  optionPreview(body: any): Observable<FXResponse<any>> {
    const url = `${APP_CONFIG.BASE_API_LINK.EMAIL_MARKETING}/preview`;
    return this.http.post(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        response.paging = res.data.paging;
        response.data = response.data.users.map((preview: any) =>
          MapUtils.deserialize(OptionPreviewModel, preview)
        );
        return response;
      })
    );
  }

  optionSend(body: any): Observable<FXResponse<any>> {
    const url = `${APP_CONFIG.BASE_API_LINK.EMAIL_MARKETING}/send`;
    return this.http.post(url, body).pipe(
      map((res: any) => {
        return new FXResponse<any>().deserialize(res);
      })
    );
  }

  preview(body: any): Observable<FXResponse<any>> {
    const url = `${APP_CONFIG.BASE_API_LINK.EMAIL_MARKETING}/preview`;
    return this.http.post(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        response.paging = res.data.paging;
        response.data = response.data.users.map((preview: any) =>
          MapUtils.deserialize(OptionPreviewModel, preview)
        );
        return response;
      })
    );
  }

  sending(body: any): Observable<any> {
    const url = `${APP_CONFIG.BASE_API_LINK.EMAIL_MARKETING}/send`;
    return this.http.post(url, body).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
